import { resolveRegionSearchCities } from '../../api/regionSearchCities';
import { ISearchCatalogItemSchema } from '../../repositories/monolith-python/entities/schemas/SearchCatalogItemSchema';
import { TTypedThunkDispatch } from '../../types/thunk';
import { IApplicationState } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { setRegionSearchCities } from './setRegionSearchCities';

export function getRegionSearchCities(text: string) {
  return (
    dispatch: TTypedThunkDispatch,
    _getState: () => IApplicationState,
    { httpApi, logger }: IApplicationContext,
  ) => {
    return resolveRegionSearchCities({ httpApi, logger, text }).then((regionCitiesData: ISearchCatalogItemSchema[]) => {
      dispatch(setRegionSearchCities(regionCitiesData));
    });
  };
}
